// ============================================================
//  FUNIL SEDES-DF 2026  |  VERSAO FINAL
// ============================================================
import { useState, useEffect, useRef } from "react";

// ─── CONFIG ───────────────────────────────────────────────────────────────────
const KIWIFY_CHECKOUT = "https://pay.kiwify.com.br/AJzXcrT";
const MEMBERS_AREA    = "https://members.kiwify.com/?club=2e03c86a-5591-40b1-835b-64e106456539";
// A captura de contato agora acontece no checkout da Kiwify (sem gate de WhatsApp).
// Não há mais envio para Google Sheets no meio do funil.

// ─── PALETA ───────────────────────────────────────────────────────────────────
const C = {
  navy: "#1B2E4B", blue: "#2563EB", blueL: "#EFF6FF",
  green: "#059669", greenL: "#ECFDF5", greenDark: "#085041",
  amber: "#D97706", amberL: "#FFFBEB",
  gray50: "#F8FAFC", gray100: "#F1F5F9", gray200: "#E2E8F0",
  gray400: "#94A3B8", gray500: "#64748B", gray700: "#334155", gray800: "#1E293B",
  white: "#FFFFFF",
};

// ─── CARGOS ───────────────────────────────────────────────────────────────────
const CARGOS = [
  { id: "200", label: "Agente Social",          codigo: "Cargo 200" },
  { id: "201", label: "Cuidador Social",         codigo: "Cargo 201" },
  { id: "202", label: "Técnico Administrativo",  codigo: "Cargo 202" },
];
const CARGO_NOMES = { "200": "Agente Social", "201": "Cuidador Social", "202": "Técnico Administrativo" };

// ─── QUIZ ─────────────────────────────────────────────────────────────────────
// Cada pergunta tem uma "chave" estável: as respostas são indexadas por chave,
// não por posição — assim reordenar as perguntas nunca quebra o cálculo de nível.
// "feedback" por opção = microfeedback reativo exibido após a resposta.
const PERGUNTAS = [
  { id: 1, chave: "tempo_estudo", texto: "Há quanto tempo você estuda para concursos?",
    opcoes: [
      { valor: "nunca", label: "Nunca estudei",       feedback: "Começar agora é uma vantagem: você ainda não tem hábitos errados pra desaprender." },
      { valor: "pouco", label: "Menos de 3 meses",    feedback: "Você está na fase certa pra construir uma base sólida sem pressa." },
      { valor: "medio", label: "3 a 12 meses",        feedback: "Esse tempo de estrada já te dá noção do que funciona e do que não funciona pra você." },
      { valor: "muito", label: "Mais de 1 ano",       feedback: "Sua persistência já é maior do que a de boa parte dos concorrentes." },
    ] },
  { id: 2, chave: "horas_dia", texto: "Quantas horas por dia você consegue estudar?",
    opcoes: [
      { valor: "menos1", label: "Menos de 1 hora",    feedback: "Anotado: seu plano vai ser desenhado pra render mesmo nesse tempo curto." },
      { valor: "1a2",    label: "1 a 2 horas",        feedback: "Tempo suficiente pra consistência, se for bem direcionado." },
      { valor: "2a4",    label: "2 a 4 horas",        feedback: "Boa margem de manobra pra cobrir mais conteúdo por semana." },
      { valor: "mais4",  label: "Mais de 4 horas",    feedback: "Esse tempo é raro, e o segredo é não desperdiçar nada dele." },
    ] },
  { id: 3, chave: "sentimento_edital", texto: "Como você se sente em relação ao conteúdo do edital?",
    opcoes: [
      { valor: "perdido",   label: "Completamente perdido",            feedback: "Esse é o ponto exato em que o Radar da Aprovação mais ajuda: ele tira a sensação de excesso de informação." },
      { valor: "iniciando", label: "Sei o que estudar mas não sei como", feedback: "Isso é mais comum do que parece. O problema raramente é o quê, é o como." },
      { valor: "andamento", label: "Já comecei mas não tenho disciplina", feedback: "Disciplina aumenta quando o caminho está claro. Falta de clareza cansa mais que falta de força de vontade." },
      { valor: "avancado",  label: "Estou avançado e preciso de foco",  feedback: "Foco é exatamente o que um estudo reverso baseado no edital resolve melhor." },
    ] },
  { id: 4, chave: "cargo", texto: "Qual cargo você vai prestar?", subtexto: "A plataforma é exclusiva para cargos de nível médio.",
    filtro: true,
    opcoes: CARGOS.map(c => ({ valor: c.id, label: `${c.label} (${c.codigo})` })) },
  { id: 5, chave: "desafio", texto: "Qual é o seu maior desafio hoje?",
    opcoes: [
      { valor: "tempo",     label: "Falta de tempo para estudar",      feedback: "Seu plano será otimizado pra render mesmo com agenda apertada." },
      { valor: "direcao",   label: "Não sei por onde começar",         feedback: "Essa é a dúvida que o estudo reverso resolve primeiro: ele te diz exatamente por onde." },
      { valor: "motivacao", label: "Falta de motivação e constância",  feedback: "Constância vem fácil quando cada dia tem uma tarefa clara, não uma lista enorme." },
      { valor: "conteudo",  label: "Dificuldade com o conteúdo",       feedback: "Seu plano vai priorizar os tópicos que a banca Quadrix mais cobra, não o edital inteiro de uma vez." },
    ] },
];

// ─── NÍVEL ────────────────────────────────────────────────────────────────────
// r é indexado por CHAVE (ex.: r.tempo_estudo), não por posição.
function calcularNivel(r) {
  if (r.tempo_estudo === "muito" && (r.horas_dia === "2a4" || r.horas_dia === "mais4") && r.sentimento_edital === "avancado") return "AVANÇADO";
  if (r.tempo_estudo === "nunca" || r.sentimento_edital === "perdido") return "INICIANTE";
  return "INTERMEDIÁRIO";
}

// Abertura personalizada do diagnóstico, a partir da resposta "desafio" (P5).
const ABERTURA_DESAFIO = {
  tempo:     "Você nos disse que o que mais pesa hoje é a falta de tempo, e é exatamente esse o gargalo que mais derruba candidato: estudar muito, mas no lugar errado. Aproveitar cada minuto disponível, sem desperdício com conteúdo que a banca Quadrix não prioriza, é o que separa quem passa de quem só se cansa.",
  direcao:   "Você nos disse que não sabe por onde começar, e essa é a primeira coisa que o estudo reverso resolve. O caminho certo nasce da ordem do que a banca Quadrix mais cobra, não do edital inteiro de uma vez.",
  motivacao: "Você nos disse que motivação e constância são o ponto mais difícil, e isso quase sempre melhora quando o caminho fica claro. Tarefas definidas, dia a dia, evitam que você abra os estudos sem saber exatamente o que fazer.",
  conteudo:  "Você nos disse que o conteúdo em si é o que mais pesa, e o segredo é focar só no que realmente cai, baseado no Radar da Aprovação e nos tópicos que a banca Quadrix mais exige.",
};
function getNivelInfo(nivel) {
  return {
    "INICIANTE":     { emoji: "🌱", cor: C.amber, bg: C.amberL, titulo: "Você está no começo, e isso é uma vantagem." },
    "INTERMEDIÁRIO": { emoji: "🚀", cor: C.blue,  bg: C.blueL,  titulo: "Você tem base. Falta organização e foco." },
    "AVANÇADO":      { emoji: "🏆", cor: C.green, bg: C.greenL, titulo: "Você está à frente. Hora de refinar e vencer." },
  }[nivel] || { emoji: "🚀", cor: C.blue, bg: C.blueL, titulo: "Falta organização e foco." };
}

// ─── DIAS ATÉ A PROVA ─────────────────────────────────────────────────────────
function diasAteProva() {
  const hoje = new Date(); const hojeZ = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
  const prova = new Date(2026, 8, 6);
  return Math.max(0, Math.round((prova - hojeZ) / 86400000));
}


// ═════════════════════════════════════════════════════════════════════════════
// APP
// Fluxo: quiz → diagnóstico (valor grátis) → breve análise → VSL/oferta → checkout.
// SEM gate de WhatsApp: o contato é capturado no checkout da Kiwify.
// ═════════════════════════════════════════════════════════════════════════════
export default function App() {
  const [tela, setTela]               = useState("nome");
  const [perguntaIdx, setPerguntaIdx] = useState(0);
  const [respostas, setRespostas]     = useState({});
  const [nome, setNome]               = useState(""); // capturado no início e usado na personalização
  const [nivel, setNivel]             = useState("");
  const [cargo, setCargo]             = useState("200");

  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    if (p.get("obrigado") === "true") {
      setNome(p.get("nome") || ""); setCargo(p.get("cargo") || "200");
      setNivel(p.get("nivel") || "INTERMEDIÁRIO"); setTela("obrigado");
    }
  }, []);

  function responder(valor) {
    const pergunta = PERGUNTAS[perguntaIdx];
    const novas = { ...respostas, [pergunta.chave]: valor };
    setRespostas(novas);
    if (pergunta.chave === "cargo") setCargo(valor);
    if (perguntaIdx < PERGUNTAS.length - 1) setPerguntaIdx(i => i + 1);
    else { setNivel(calcularNivel(novas)); setTela("diagnostico"); window.scrollTo(0, 0); }
  }

  function irParaCarregando() { setTela("carregando"); window.scrollTo(0, 0); }
  function irParaVSL()        { setTela("vsl");        window.scrollTo(0, 0); }

  const nivelInfo  = getNivelInfo(nivel);
  const cargoLabel = CARGO_NOMES[cargo] || "";

  return (
    <div style={S.root}>
      {tela === "nome"        && <TelaNome nome={nome} setNome={setNome} onComecar={() => { setTela("quiz"); window.scrollTo(0, 0); }} />}
      {tela === "quiz"        && <TelaQuiz perguntaIdx={perguntaIdx} responder={responder} />}
      {tela === "diagnostico" && <TelaDiagnostico nome={nome} nivel={nivel} nivelInfo={nivelInfo} cargoLabel={cargoLabel} respostas={respostas} onIr={irParaCarregando} />}
      {tela === "carregando"  && <TelaCarregando nome={nome} cargo={cargo} onAvancar={irParaVSL} />}
      {tela === "vsl"         && <TelaVSL nome={nome} onComprar={() => window.open(KIWIFY_CHECKOUT, "_blank")} />}
      {tela === "obrigado"    && <TelaObrigado nome={nome} diasAteProva={diasAteProva()} />}
    </div>
  );
}

// ═════════════════════════════════════════════════════════════════════════════
// CAPTURA DE NOME — primeira tela. Apenas o primeiro nome, para personalizar a jornada.
// Não é gate de contato: nada é prometido em troca, é só personalização.
function TelaNome({ nome, setNome, onComecar }) {
  const [erro, setErro] = useState(false);
  function handle() { if (!nome.trim()) { setErro(true); return; } setErro(false); onComecar(); }
  return (
    <div style={S.tela}><div style={S.logoWrap}><div style={S.logoIcon}>🎯</div><div style={S.logoTxt}>MISSÃO SEDES-DF 2026</div></div>
      <div style={S.card}>
        <span style={S.badge}>4.788 vagas abertas · Prova: 06/09/2026</span>
        <h1 style={S.h1}>Simulador de Aprovação SEDES-DF</h1>
        <p style={S.lead}>Em 5 perguntas você descobre seu nível real e o caminho até a aprovação. Antes, como podemos te chamar?</p>
        <input style={S.input} type="text" placeholder="Seu primeiro nome" value={nome}
          onChange={e => { setNome(e.target.value); setErro(false); }}
          onKeyDown={e => { if (e.key === "Enter") handle(); }} />
        {erro && <p style={{ fontSize: 13, color: "#DC2626", marginTop: 6 }}>⚠️ Digite seu nome para começar.</p>}
        <button style={S.btnPrimary} onClick={handle}>Começar meu diagnóstico →</button>
      </div>
    </div>
  );
}

// ═════════════════════════════════════════════════════════════════════════════
function TelaQuiz({ perguntaIdx, responder }) {
  const p = PERGUNTAS[perguntaIdx];
  const pct = (perguntaIdx / PERGUNTAS.length) * 100;
  const [selecionada, setSelecionada] = useState(null); // valor da opção clicada
  const [feedback, setFeedback] = useState("");          // microfeedback em exibição
  const [travado, setTravado] = useState(false);         // evita duplo clique

  // Reseta o estado local sempre que a pergunta muda
  useEffect(() => { setSelecionada(null); setFeedback(""); setTravado(false); }, [perguntaIdx]);

  function escolher(op) {
    if (travado) return;
    setTravado(true);
    setSelecionada(op.valor);
    if (op.feedback) {
      setFeedback(op.feedback);
      setTimeout(() => responder(op.valor), 2000); // reduzido de 3200 → 2000ms p/ cortar a espera forçada
    } else {
      responder(op.valor); // perguntas-filtro (cargo) avançam direto
    }
  }

  return (
    <div style={S.tela}><div style={S.logoWrap}><div style={S.logoIcon}>🎯</div><div style={S.logoTxt}>MISSÃO SEDES-DF 2026</div></div>
      <div style={S.card}>
        <span style={S.badge}>4.788 vagas abertas · Prova: 06/09/2026</span>
        <h1 style={S.h1}>Simulador de Aprovação</h1>
        <p style={S.lead}>Qual é o seu real nível para o SEDES-DF? 5 perguntas revelam tudo, e o que fazer a partir de hoje.</p>
        <div style={S.progressBar}><div style={{ ...S.progressFill, width: `${pct}%` }} /></div>
        <p style={S.progressLbl}>Pergunta {perguntaIdx + 1} de {PERGUNTAS.length}</p>
        <h2 style={S.h2}>{p.texto}</h2>
        {p.subtexto && <p style={S.aviso}>{p.subtexto}</p>}
        <div style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 16 }}>
          {p.opcoes.map(op => {
            const ativa = selecionada === op.valor;
            return (
              <button key={op.valor}
                style={{ ...S.opcao,
                  borderColor: ativa ? C.blue : C.gray200,
                  background: ativa ? C.blueL : C.white,
                  opacity: travado && !ativa ? 0.55 : 1,
                  cursor: travado ? "default" : "pointer" }}
                onMouseEnter={e => { if (!travado) { e.currentTarget.style.borderColor = C.blue; e.currentTarget.style.background = C.blueL; } }}
                onMouseLeave={e => { if (!travado && !ativa) { e.currentTarget.style.borderColor = C.gray200; e.currentTarget.style.background = C.white; } }}
                onClick={() => escolher(op)}>{op.label}</button>
            );
          })}
        </div>

        {/* Microfeedback reativo */}
        {feedback && (
          <div style={{ background: C.blueL, border: `1px solid ${C.blue}33`, borderRadius: 10, padding: "12px 14px", marginTop: 14, display: "flex", gap: 9, alignItems: "flex-start", animation: "fbIn .3s ease both" }}>
            <style>{`@keyframes fbIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}`}</style>
            <span style={{ fontSize: 18, flexShrink: 0 }}>💬</span>
            <p style={{ fontSize: 13.5, color: C.navy, lineHeight: 1.55, margin: 0 }}>{feedback}</p>
          </div>
        )}

        {/* O que o lead recebe — agora SEM prometer o cronograma (que é o produto pago).
            O valor grátis é o diagnóstico, que ABRE o problema em vez de entregar a solução. */}
        <div style={S.promessa}>
          <p style={S.promessaTit}>Ao final você recebe:</p>
          <p style={S.promessaItem}>✅ Um diagnóstico honesto do seu nível real</p>
          <p style={S.promessaItem}>🧭 Clareza sobre o seu maior gargalo até a prova</p>
        </div>
      </div>
    </div>
  );
}

// ═════════════════════════════════════════════════════════════════════════════
// DIAGNÓSTICO — valor grátis (nível + gargalo + urgência). SEM formulário.
// O botão leva direto para a oferta (o cronograma/plano é o que se compra).
function TelaDiagnostico({ nome, nivel, nivelInfo, cargoLabel, respostas, onIr }) {
  const pnome = (nome || "").split(" ")[0] || "Candidato";
  const abertura = ABERTURA_DESAFIO[respostas && respostas.desafio];
  const dias = diasAteProva();
  return (
    <div style={S.tela}><div style={S.logoWrap}><div style={S.logoIcon}>🎯</div><div style={S.logoTxt}>MISSÃO SEDES-DF 2026</div></div>
      <div style={S.card}>
        <div style={{ textAlign: "center", marginBottom: 20 }}><span style={{ fontSize: 56 }}>{nivelInfo.emoji}</span><h1 style={{ ...S.h1, marginTop: 8 }}>{pnome}, seu diagnóstico está pronto</h1></div>
        <div style={{ background: nivelInfo.bg, border: `2px solid ${nivelInfo.cor}`, borderRadius: 14, padding: 20, textAlign: "center", marginBottom: 20 }}>
          <p style={{ fontSize: 12, color: C.gray500, marginBottom: 4, fontWeight: 600, textTransform: "uppercase", letterSpacing: 1 }}>Seu nível atual</p>
          <p style={{ fontSize: 36, fontWeight: 900, color: nivelInfo.cor, margin: "0 0 4px" }}>{nivel}</p>
          {cargoLabel && <p style={{ fontSize: 13, color: C.gray500, margin: "0 0 12px" }}>Cargo: <strong style={{ color: C.navy }}>{cargoLabel}</strong></p>}
          <p style={{ fontSize: 15, color: C.gray700, lineHeight: 1.7, margin: 0 }}>{nivelInfo.titulo}</p>
        </div>

        {/* Abertura personalizada — nome + resposta de "maior desafio" (P5) */}
        {abertura && (
          <div style={{ marginBottom: 20, paddingLeft: 14, borderLeft: `4px solid ${nivelInfo.cor}` }}>
            <p style={{ fontSize: 14.5, color: C.gray700, lineHeight: 1.7, margin: 0 }}><strong style={{ color: C.navy }}>{pnome}</strong>, {abertura.charAt(0).toLowerCase() + abertura.slice(1)}</p>
          </div>
        )}

        <div style={{ background: C.gray50, borderRadius: 12, padding: 20, marginBottom: 20, borderLeft: `4px solid ${C.navy}` }}>
          <p style={{ fontSize: 15, color: C.navy, fontWeight: 700, marginBottom: 8 }}>⚠️ Faltam {dias} dias para a prova (06/09/2026).</p>
          <p style={{ fontSize: 14, color: C.gray700, lineHeight: 1.7, margin: 0 }}>E a maioria dos candidatos vai chegar lá tendo estudado muito, só que <strong>no lugar errado</strong>. Tempo gasto com o que quase não cai, enquanto o que decide a prova fica de fora.</p>
        </div>

        {/* MÉTODO — o "como passar". Bridge problema → solução → oferta. */}
        <div style={{ background: `linear-gradient(160deg, ${C.navy}, #14233b)`, borderRadius: 14, padding: 22, marginBottom: 24, color: "#fff" }}>
          <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1.5, textTransform: "uppercase", color: "#7FB4FF", margin: "0 0 10px" }}>O caminho que aprova</p>
          <p style={{ fontSize: 18.5, fontWeight: 800, lineHeight: 1.4, margin: "0 0 14px" }}>
            Quem passa não é quem sabe mais.<br />É quem <span style={{ color: "#FBBF24" }}>acerta mais questões.</span>
          </p>
          <p style={{ fontSize: 14, lineHeight: 1.7, color: "#D7E0EC", margin: "0 0 12px" }}>
            E acertar questão não vem de assistir horas de videoaula nem de ler PDF atrás de PDF. Vem de estudo objetivo, direto ao ponto, com revisão por questões.
          </p>
          <p style={{ fontSize: 14, lineHeight: 1.7, color: "#D7E0EC", margin: "0 0 4px" }}>
            O método que aprova num concurso como o SEDES-DF é o <strong style={{ color: "#fff" }}>Estudo Reverso</strong>: você analisa o edital, identifica <strong style={{ color: "#fff" }}>o que tem mais peso</strong> e <strong style={{ color: "#fff" }}>o que a banca Quadrix mais cobra</strong>, e monta um plano que prioriza o que de fato decide a prova, em vez de tentar abraçar o edital inteiro.
          </p>
          <div style={{ background: "rgba(255,255,255,.08)", borderLeft: "3px solid #FBBF24", borderRadius: 8, padding: "12px 14px", margin: "16px 0" }}>
            <p style={{ fontSize: 14, lineHeight: 1.6, color: "#fff", margin: 0, fontWeight: 600 }}>
              Pra quem tem pouco tempo, ou está estudando depois do edital já publicado, essa é a única forma realista de passar. Não dá pra estudar tudo. Dá pra estudar o que cai.
            </p>
          </div>
          <p style={{ fontSize: 14, lineHeight: 1.7, color: "#D7E0EC", margin: 0 }}>
            Você pode fazer isso sozinho: mapear o edital, separar as matérias por peso e estudar na unha. Funciona, mas leva tempo. Se você quer <strong style={{ color: "#fff" }}>velocidade</strong> e chegar à prova com o plano <strong style={{ color: "#fff" }}>já pronto</strong>, o atalho está logo abaixo. 👇
          </p>
        </div>

        {/* CTA direto para a oferta — sem cadastro, sem gate, sem isca-e-troca */}
        <div style={{ borderTop: `1px solid ${C.gray200}`, paddingTop: 20 }}>
          <button style={S.btnPrimary} onClick={onIr}>⚡ Quero o plano pronto e chegar mais rápido</button>
          <p style={{ fontSize: 12, color: C.gray400, textAlign: "center", marginTop: 10 }}>Leva 3 minutos · sem cadastro</p>
        </div>
      </div>
    </div>
  );
}

// ═════════════════════════════════════════════════════════════════════════════
// BREVE TELA DE ANÁLISE — bridge para a VSL. Curta, sem prometer entrega no WhatsApp.
const DURACAO_CARREGANDO = 2200; // ms

function TelaCarregando({ nome, cargo, onAvancar }) {
  const pnome = (nome || "").split(" ")[0] || "Candidato";
  const cargoLbl = CARGO_NOMES[cargo] || "seu cargo";
  const mensagens = [
    `Cruzando suas respostas com o edital de ${cargoLbl}`,
    "Aplicando o peso da banca Quadrix",
    "Montando sua análise completa",
  ];
  const [passo, setPasso] = useState(0);

  useEffect(() => {
    const intervalo = DURACAO_CARREGANDO / mensagens.length;
    const tInterval = setInterval(() => setPasso(p => Math.min(p + 1, mensagens.length - 1)), intervalo);
    const tRedirect = setTimeout(() => onAvancar(), DURACAO_CARREGANDO);
    return () => { clearInterval(tInterval); clearTimeout(tRedirect); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const pct = ((passo + 1) / mensagens.length) * 100;

  return (
    <div style={S.telaTrans}>
      <div style={S.logoWrap}><div style={S.logoIcon}>🎯</div><div style={S.logoTxt}>MISSÃO SEDES-DF 2026</div></div>

      <div style={{ ...S.card, padding: 28, textAlign: "center" }}>
        <div style={{ fontSize: 38, marginBottom: 16, animation: "girar 1.3s linear infinite" }}>⚙️</div>
        <style>{`@keyframes girar{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}`}</style>

        <p style={{ fontSize: 15.5, fontWeight: 700, color: C.navy, margin: "0 0 6px" }}>Quase lá, {pnome}! Preparando sua análise...</p>
        <p style={{ fontSize: 13.5, color: C.gray500, lineHeight: 1.5, margin: "0 0 18px", minHeight: 20, transition: "opacity .25s ease" }}>
          {mensagens[passo]}
        </p>

        <div style={S.progressBar}><div style={{ ...S.progressFill, width: `${pct}%` }} /></div>
      </div>
    </div>
  );
}

// ═════════════════════════════════════════════════════════════════════════════
// PÁGINA DE VENDAS / VSL
// Acima da dobra (sempre visível): apenas Headline + Vídeo (VSL).
// Liberado no pitch aos 3:45 (Opção B, timer): Botão → entregáveis → modelo de cronograma
// → box de convencimento → garantia → depoimentos → FAQ → botão final.
// ─── ENTREGÁVEL (card de item da lista de bônus/acervo) ──────────────────────────
function Entregavel({ icon, titulo, desc }) {
  return (
    <div style={{ display: "flex", gap: 10, alignItems: "flex-start", marginBottom: 12 }}>
      <span style={{ fontSize: 20, lineHeight: 1.4, flexShrink: 0 }}>{icon}</span>
      <div>
        <p style={{ fontSize: 14, fontWeight: 700, color: C.navy, margin: 0, lineHeight: 1.4 }}>{titulo}</p>
        {desc && (
          <p style={{ fontSize: 13, color: C.gray700, margin: "2px 0 0", lineHeight: 1.6 }}>{desc}</p>
        )}
      </div>
    </div>
  );
}

function TelaVSL({ nome, onComprar }) {
  const pnome = (nome || "").split(" ")[0] || "Candidato";

  // Opção B — timer. A VSL é autoplay, então o relógio começa junto com o load.
  // 3:45 = 225 segundos = 225000 ms. Ajuste aqui se o pitch mudar de segundo.
  const [revelado, setRevelado] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setRevelado(true), 225000); // 3:45 (momento do preço)
    return () => clearTimeout(t);
  }, []);

  return (
    <div style={S.telaVsl}>
      {/* Headline personalizada — sem promessa de WhatsApp, conecta com o diagnóstico */}
      <p style={{ textAlign: "center", fontSize: 17.5, fontWeight: 800, color: C.navy, margin: "0 0 12px", lineHeight: 1.4 }}>
        {pnome}, você fez o diagnóstico. Agora, <span style={{ color: C.blue }}>3 minutos</span> que decidem se você vai estudar o certo ou se afogar no edital inteiro.
      </p>

      {/* Vídeo */}
      <div style={{ position: "relative", borderRadius: 14, overflow: "hidden", boxShadow: "0 4px 20px rgba(0,0,0,.18)" }}>
        <link rel="preload" href="https://scripts.converteai.net/81cb9a92-d3cc-4311-b5ce-c365a7e5f19a/players/6a49ab3a1af24c3514971981/v4/player.js" as="script" />
        <link rel="preload" href="https://scripts.converteai.net/lib/js/smartplayer-wc/v4/smartplayer.js" as="script" />
        <link rel="preload" href="https://cdn.converteai.net/81cb9a92-d3cc-4311-b5ce-c365a7e5f19a/6a49aada12467ad3e4974f99/main.m3u8" as="fetch" />
        <link rel="dns-prefetch" href="https://cdn.converteai.net" /><link rel="dns-prefetch" href="https://scripts.converteai.net" /><link rel="dns-prefetch" href="https://images.converteai.net" /><link rel="dns-prefetch" href="https://license.vturb.com" />
        <VturbPlayer />
      </div>

      {/* ───────── LIBERADO NO PITCH (3:45): botão + demais entregáveis ───────── */}
      {revelado && (
        <div style={{ animation: "fadeUp .6s ease both" }}>
          <style>{`@keyframes fadeUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}`}</style>

          {/* Botão de compra — aparece junto do pitch */}
          <button
            style={{ ...S.btnGreen, marginTop: 20, padding: "18px 24px", fontSize: 17, boxShadow: "0 6px 22px rgba(5,150,105,.4)", animation: "pulseCta 2.2s ease-in-out infinite" }}
            onClick={onComprar}>
            🔓 Garantir meu acesso por R$67
          </button>
          <style>{`@keyframes pulseCta {0%,100%{transform:scale(1)}50%{transform:scale(1.03)}}`}</style>

          {/* O que está incluso */}
          <div style={{ ...S.card, marginTop: 20 }}>
            <h3 style={S.h3}>O que você acessa na Plataforma<br /><span style={{ color: C.blue }}>Missão SEDES DF 2026</span></h3>

            {/* Ponte de coerência — reconcilia "conteúdo completo" com o Estudo Reverso. */}
            <p style={{ fontSize: 14, color: C.gray700, lineHeight: 1.7, margin: "0 0 18px" }}>
              Você <strong> vai estudar o edital inteiro, mas de modo estratégico</strong>. Vai estudar o que cai, na ordem certa. A plataforma tem todo o conteúdo que pode aparecer na prova, mas você nunca vê tudo de uma vez. O app cruza o peso da banca com as horas que você marcou e entrega só a tarefa do dia. <strong style={{ color: C.navy }}>O conteúdo completo é a munição. O app é a mira.</strong>
            </p>

            {/* HERÓI — o app é o que cumpre a promessa do Estudo Reverso. */}
            <div style={{ background: C.blueL, border: `1.5px solid ${C.blue}55`, borderRadius: 12, padding: "14px 16px 4px", marginBottom: 16 }}>
              <Entregavel icon="📱" titulo="Seu Plano de Estudo no App, o coração da plataforma"
                desc="Você diz quantas horas tem por dia. O app monta seu plano priorizado pelo que a banca Quadrix mais cobra e te mostra só o que estudar HOJE, sem se afogar no edital. Mudou sua rotina? O plano se reorganiza sozinho." />
            </div>

            <Entregavel icon="🎓" titulo="Aula de Metodologia" desc="Uma aula objetiva que mostra como aplicar o método e estudar do jeito certo. Não é um curso em vídeo, é o mapa pra usar a plataforma com foco. Inclui Caderno de Erros com IA + Planilha de Desempenho." />
            <Entregavel icon="🎯" titulo="Radar da Aprovação" desc="Mapeamento dos Tópicos Mais Cobrados pela Banca Quadrix + Checklist" />

            {/* Blocos reenquadrados como ACERVO que o app puxa — não como currículo a vencer. */}
            <p style={{ fontSize: 13, fontWeight: 700, color: C.gray500, margin: "16px 0 10px" }}>📚 O acervo que o app puxa pra você:</p>
            <Entregavel icon="📚" titulo="Bloco 1: Conhecimentos Gerais" desc="Língua Portuguesa · Conhecimentos do DF · Política para Mulheres · Legislação · Primeiros Socorros" />
            <Entregavel icon="⚖️" titulo="Bloco 2: Conhecimentos Específicos Comuns" desc="SUAS e PNAS 2004 · Programas e Benefícios Socioassistenciais do DF" />
            <Entregavel icon="🎯" titulo="Módulo Específico do Seu Cargo" desc="Agente Social (200) · Cuidador Social (201) · Técnico Administrativo (202)" />
            <Entregavel icon="📖" titulo="Biblioteca de Leis + Glossário" desc="Todo o material de referência sem garimpar na internet" />
            <Entregavel icon="🎁" titulo="3 Bônus Exclusivos" desc={'Método Redação Nota 10 · Podcast "Entendendo o SUAS" · Pack de Flashcards "Benefícios Sociais do DF"'} />
          </div>

          {/* Modelo de cronograma — prova de mecanismo (o app rodando), logo após os entregáveis */}
          <div style={{ ...S.card, marginTop: 16 }}>
            <h3 style={S.h3}>🎯 O Estudo Reverso na prática</h3>
            <MockupPlano pnome={pnome} />
            <p style={{ fontSize: 11.5, color: C.gray400, textAlign: "center", margin: "8px 0 14px" }}>Prévia do seu painel de estudos dentro da plataforma</p>
            <p style={{ fontSize: 14, color: C.gray700, lineHeight: 1.7, margin: 0 }}>
              Em vez de "estude Legislação", o Radar mostra <strong style={{ color: C.navy }}>exatamente quais pontos a banca Quadrix mais cobra</strong>, e o app coloca eles primeiro no seu plano. É isso que você vê já no dia 1.
            </p>
          </div>

          {/* Ancoragem de valor — ROI pelo salário real + alternativas. Sem preço fantasma. */}
          <div style={{ ...S.card, marginTop: 16, borderLeft: `4px solid ${C.green}` }}>
            <h3 style={S.h3}>Quanto vale chegar na prova com o plano pronto?</h3>
            <p style={{ fontSize: 14, color: C.gray700, lineHeight: 1.8, margin: "0 0 14px" }}>
              Um cursinho preparatório pra esse concurso custa <strong>centenas de reais</strong>. Uma mentoria de planejamento, <strong>mais ainda</strong>. Montar o plano sozinho, mapeando o edital na unha, custa <strong>semanas</strong> que você não tem.
            </p>
            <div style={{ background: C.greenL, borderRadius: 10, padding: "14px 16px" }}>
              <p style={{ fontSize: 15, color: C.navy, fontWeight: 700, lineHeight: 1.75, margin: 0 }}>
                O cargo paga <strong style={{ color: C.greenDark }}>R$ 4.762,97/mês</strong> (+ auxílios e gratificações).<br />
                O acesso completo até o dia da prova, por um preço especial: <strong style={{ color: C.green }}>R$ 67</strong>.
              </p>
            </div>
          </div>

          {/* Garantia de 7 dias */}
          <div style={{ ...S.card, marginTop: 16, textAlign: "center", border: `2px solid ${C.greenL}` }}>
            <span style={{ fontSize: 44 }}>🛡️</span>
            <h3 style={{ color: C.green, fontSize: 18, fontWeight: 700, margin: "8px 0" }}>Garantia de 7 dias sem risco</h3>
            <p style={{ fontSize: 14, color: C.gray500, lineHeight: 1.6, margin: 0 }}>Se por qualquer motivo não ficar satisfeito, devolvemos 100% do seu dinheiro. Sem perguntas.</p>
          </div>

          {/* Depoimentos — inalterados.
              >>> TROQUE por prints reais de WhatsApp/alunos assim que tiver — converte muito mais. */}
          <div style={{ ...S.card, marginTop: 16 }}>
            <h3 style={S.h3}>O que estão dizendo</h3>
            <Depoimento iniciais="FR" nome="Fernanda R." txt="O conteúdo é incrível. Tava esperando uma apostila e me surpreendi com uma metodologia completa." />
            <Depoimento iniciais="CM" nome="Carla M." txt="Eu estava travada com tanto conteúdo. Agora estou conseguindo estudar de verdade." />
          </div>

          {/* FAQ — por último */}
          <div style={{ ...S.card, marginTop: 16 }}>
            <h3 style={S.h3}>Perguntas frequentes</h3>
            <FaqItem q="Material atualizado com o edital?" a="Sim. Contempla todas as normativas, legislações e retificações mais recentes do Edital SEDES-DF." />
            <FaqItem q="E se a metodologia não for para mim?" a="Risco zero. 7 dias de Garantia Incondicional. Basta um clique ou e-mail e devolvemos 100% sem burocracia." />
            <FaqItem q="Por quanto tempo terei acesso?" a="Até a data oficial da prova. Se a data for alterada, o acesso é automaticamente expandido." />
            <FaqItem q="O curso tem conteúdo para os cargos de nível superior?" a="Não. O foco é exclusivamente nos cargos de nível médio." />
          </div>

          {/* CTA final — inalterado */}
          <div style={{ marginTop: 16 }}>
            <button style={{ ...S.btnGreen, padding: "18px 24px", fontSize: 16.5 }} onClick={onComprar}>🔓 Garantir meu acesso agora por R$67</button>
            <p style={{ fontSize: 12, color: C.amber, textAlign: "center", marginTop: 8, fontWeight: 600 }}>🔥 R$67 é uma condição especial por tempo limitado.</p>
          </div>
        </div>
      )}

      {/* Fale conosco — WhatsApp flutuante no canto: aparece SÓ junto do botão de compra (revelado no pitch, 3:45) */}
      {revelado && (
        <a href="https://wa.link/hi1ifa" target="_blank" rel="noreferrer"
        style={{ position: "fixed", bottom: 18, right: 18, zIndex: 50, display: "flex", alignItems: "center", gap: 8, background: "#25D366", color: "#fff", textDecoration: "none", padding: "11px 16px", borderRadius: 30, boxShadow: "0 4px 14px rgba(0,0,0,.28)", fontSize: 13.5, fontWeight: 700, fontFamily: "inherit" }}>
        <svg viewBox="0 0 24 24" width="19" height="19" fill="#fff" style={{ flexShrink: 0 }}><path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.945C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 018.413 3.488 11.824 11.824 0 013.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 001.51 5.26l-.999 3.648 3.879-1.317zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/></svg>
        Fale conosco
        </a>
      )}
    </div>
  );
}


// ═════════════════════════════════════════════════════════════════════════════
function TelaObrigado({ diasAteProva }) {
  return (
    <div style={S.tela}><div style={S.logoWrap}><div style={S.logoIcon}>🎯</div><div style={S.logoTxt}>MISSÃO SEDES-DF 2026</div></div>
      <div style={S.card}>
        <div style={{ textAlign: "center", marginBottom: 24 }}><span style={{ fontSize: 64 }}>🎉</span><h1 style={{ ...S.h1, color: C.green, marginTop: 8 }}>Parabéns, sua compra foi confirmada!</h1><p style={{ fontSize: 15, color: C.gray700 }}>Bem-vindo à Plataforma Missão SEDES.<br />Faltam <strong>{diasAteProva} dias</strong> para a prova.</p></div>
        <div style={{ background: C.gray50, borderRadius: 12, padding: 20, marginBottom: 20 }}>
          <p style={{ fontWeight: 700, color: C.navy, fontSize: 15, marginBottom: 14 }}>Próximos passos</p>
          {["Acesse a plataforma com o botão abaixo", "Assista à videoaula de Metodologia", "Comece hoje, cada semana conta!"].map((t, i) => (
            <div key={i} style={{ display: "flex", gap: 12, marginBottom: 12 }}><div style={{ background: C.blue, color: "#fff", borderRadius: "50%", width: 26, height: 26, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: 13, flexShrink: 0 }}>{i + 1}</div><p style={{ fontSize: 14, color: C.gray700, margin: 0, paddingTop: 3 }}>{t}</p></div>
          ))}
        </div>
        <div style={{ background: C.blueL, border: `1px solid ${C.blue}22`, borderRadius: 12, padding: 16, marginBottom: 20 }}><p style={{ fontSize: 14, color: C.navy, lineHeight: 1.7, margin: 0 }}>📱 Seu cronograma personalizado está disponível direto no APP, dentro da plataforma.<br /><span style={{ fontSize: 13, color: C.gray500 }}>📧 O link de acesso também será enviado para o seu e-mail.</span></p></div>
        <a href={MEMBERS_AREA} target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}><button style={S.btnGreen}>🎓 Acessar a Plataforma Missão SEDES agora</button></a>
      </div>
    </div>
  );
}

// ═════════════════════════════════════════════════════════════════════════════
// MOCKUP DO PAINEL — reproduz o painel real do app (cronograma priorizado) como
// prova de mecanismo na VSL. Personaliza o cabeçalho com o nome do lead.
function MockupPlano({ pnome }) {
  const dias = diasAteProva();
  const topicos = [
    { nome: "Interpretação e compreensão de textos", rel: "Altíssima", feito: true },
    { nome: "Concordância verbal e nominal",         rel: "Alta",      feito: true },
    { nome: "Regência e crase",                       rel: "Alta",      feito: false },
    { nome: "Ortografia e acentuação",                rel: "Média",     feito: false },
  ];
  const relCor = { "Altíssima": C.green, "Alta": C.blue, "Média": C.gray500 };
  return (
    <div style={{ border: `1px solid ${C.gray200}`, borderRadius: 12, overflow: "hidden", boxShadow: "0 6px 20px rgba(0,0,0,.10)", background: C.white }}>
      {/* Cabeçalho */}
      <div style={{ background: C.gray50, padding: "12px 14px", borderBottom: `1px solid ${C.gray200}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <p style={{ margin: 0, fontWeight: 800, color: C.navy, fontSize: 14 }}>Olá, {pnome} 👋</p>
          <p style={{ margin: "2px 0 0", color: C.gray500, fontSize: 11.5 }}>Cargo 200 · Agente Social</p>
        </div>
        <span style={{ color: C.gray400, fontSize: 11.5 }}>Sair</span>
      </div>
      {/* Banner do cronograma */}
      <div style={{ margin: 12, background: C.greenL, border: `1px solid ${C.green}33`, borderRadius: 8, padding: "10px 12px", color: C.greenDark, fontSize: 11.5, lineHeight: 1.5 }}>
        🎯 Cronograma gerado com base no Radar da Aprovação e nas suas <strong>2h/dia</strong>. Marque os tópicos conforme estudar; progresso salvo automaticamente.
      </div>
      {/* Indicadores */}
      <div style={{ display: "flex", gap: 8, padding: "0 12px" }}>
        {[[String(dias), "dias para a prova"], ["11", "semanas no plano"], ["5%", "concluído"]].map(([n, l], i) => (
          <div key={i} style={{ flex: 1, border: `1px solid ${C.gray200}`, borderRadius: 8, padding: "10px 6px", textAlign: "center" }}>
            <p style={{ margin: 0, fontWeight: 800, color: C.navy, fontSize: 17 }}>{n}</p>
            <p style={{ margin: "2px 0 0", color: C.gray500, fontSize: 10.5 }}>{l}</p>
          </div>
        ))}
      </div>
      {/* Progresso geral */}
      <div style={{ margin: 12, border: `1px solid ${C.gray200}`, borderRadius: 8, padding: "10px 12px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
          <span style={{ fontWeight: 700, color: C.navy, fontSize: 12.5 }}>Progresso geral</span>
          <span style={{ color: C.gray400, fontSize: 11 }}>8/154 · ✓ salvo</span>
        </div>
        <div style={{ background: C.gray200, borderRadius: 6, height: 6 }}><div style={{ width: "5%", height: 6, borderRadius: 6, background: C.green }} /></div>
      </div>
      {/* Semana 1 */}
      <div style={{ margin: "12px 12px 0", background: C.navy, color: "#fff", borderRadius: "8px 8px 0 0", padding: "10px 12px", display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ background: C.blue, borderRadius: "50%", width: 20, height: 20, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700, flexShrink: 0 }}>1</span>
        <strong style={{ fontSize: 12.5, flex: 1 }}>Semana 1</strong>
        <span style={{ fontSize: 11, color: "#9DB4D4" }}>8/14 tópicos</span>
      </div>
      <div style={{ margin: "0 12px 12px", border: `1px solid ${C.gray200}`, borderTop: "none", borderRadius: "0 0 8px 8px", paddingBottom: 6 }}>
        <p style={{ margin: "0", padding: "8px 12px 6px", fontSize: 10.5, fontWeight: 700, color: C.gray500, letterSpacing: 0.5, background: C.gray50 }}>LÍNGUA PORTUGUESA</p>
        {topicos.map((t, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", gap: 9, padding: "8px 12px", borderTop: `1px solid ${C.gray100}` }}>
            <span style={{ width: 17, height: 17, borderRadius: 4, flexShrink: 0, background: t.feito ? C.green : C.white, border: t.feito ? "none" : `1.5px solid ${C.gray200}`, color: "#fff", fontSize: 11, display: "inline-flex", alignItems: "center", justifyContent: "center" }}>{t.feito ? "✓" : ""}</span>
            <span style={{ flex: 1, color: t.feito ? C.gray400 : C.gray800, textDecoration: t.feito ? "line-through" : "none", fontSize: 12.5, lineHeight: 1.3 }}>{t.nome}</span>
            <span style={{ fontSize: 10, fontWeight: 700, color: relCor[t.rel], background: `${relCor[t.rel]}18`, borderRadius: 20, padding: "2px 9px", flexShrink: 0 }}>{t.rel}</span>
          </div>
        ))}
      </div>
    </div>
  );
}


function Depoimento({ iniciais, nome, txt }) { return (<div style={{ background: C.gray50, border: `1px solid ${C.gray200}`, borderRadius: 12, padding: 16, marginBottom: 10 }}><div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 10 }}><div style={S.avatarCircle}>{iniciais}</div><div><p style={{ fontWeight: 700, color: C.navy, fontSize: 14, margin: 0 }}>{nome}</p><span style={{ fontSize: 12 }}>⭐⭐⭐⭐⭐</span></div></div><p style={{ fontSize: 14, color: C.gray700, lineHeight: 1.6, margin: 0, fontStyle: "italic" }}>"{txt}"</p></div>); }
function FaqItem({ q, a }) { const [open, setOpen] = useState(false); return (<div style={{ border: `1px solid ${C.gray200}`, borderRadius: 10, marginBottom: 8, overflow: "hidden" }}><button style={{ width: "100%", background: open ? C.blueL : C.white, border: "none", padding: "14px 16px", color: C.navy, fontSize: 14, fontWeight: 600, textAlign: "left", cursor: "pointer", display: "flex", justifyContent: "space-between", gap: 8 }} onClick={() => setOpen(o => !o)}><span>{q}</span><span style={{ color: C.blue, flexShrink: 0 }}>{open ? "▲" : "▼"}</span></button>{open && <p style={{ padding: "0 16px 14px", fontSize: 14, color: C.gray700, lineHeight: 1.6, margin: 0 }}>{a}</p>}</div>); }
function VturbPlayer() {
  const ref = useRef(null);
  useEffect(() => {
    window._plt = window._plt || (window.performance && performance.timeOrigin ? performance.timeOrigin + performance.now() : Date.now());
    const PLAYER_SRC = "https://scripts.converteai.net/81cb9a92-d3cc-4311-b5ce-c365a7e5f19a/players/6a49ab3a1af24c3514971981/v4/player.js";
    // Injeta o markup EXATAMENTE como o embed oficial (com o placeholder), só se ainda não existir.
    if (ref.current && !ref.current.querySelector("vturb-smartplayer")) {
      ref.current.innerHTML = '<vturb-smartplayer id="vid-6a49ab3a1af24c3514971981" style="display: block; margin: 0 auto; width: 100%;"><div class="vturb-player-placeholder" style="position: relative; width: 100%; padding: 56.25% 0 0; z-index: 0; background-color: black;"></div></vturb-smartplayer>';
    }
    // Carrega o script do player UMA ÚNICA VEZ (não remove no cleanup) para não re-registrar o custom element.
    if (!document.querySelector('script[src="' + PLAYER_SRC + '"]')) {
      const s = document.createElement("script");
      s.src = PLAYER_SRC;
      s.async = true;
      document.head.appendChild(s);
    }
  }, []);
  return <div ref={ref} style={{ width: "100%" }} />;
}

// ═════════════════════════════════════════════════════════════════════════════
const S = {
  root: { minHeight: "100vh", background: C.gray100, fontFamily: "'Inter','Segoe UI',system-ui,sans-serif", color: C.gray800 },
  tela: { maxWidth: 640, margin: "0 auto", padding: "20px 16px 80px" },
  logoWrap: { display: "flex", alignItems: "center", gap: 10, marginBottom: 16, justifyContent: "center" },
  logoIcon: { fontSize: 24 }, logoTxt: { fontSize: 14, fontWeight: 800, color: C.navy, letterSpacing: 0.5 },
  card: { background: C.white, borderRadius: 16, padding: 24, boxShadow: "0 1px 6px rgba(0,0,0,.07)" },
  badge: { display: "inline-block", background: C.navy, color: "#fff", borderRadius: 20, padding: "4px 14px", fontSize: 12, fontWeight: 700, marginBottom: 12 },
  h1: { fontSize: 22, fontWeight: 800, color: C.navy, margin: "0 0 8px", lineHeight: 1.3 },
  h2: { fontSize: 17, fontWeight: 700, color: C.navy, margin: "0 0 8px" },
  h3: { fontSize: 16, fontWeight: 700, color: C.navy, margin: "0 0 16px" },
  lead: { fontSize: 14, color: C.gray500, margin: "0 0 20px" },
  aviso: { fontSize: 13, color: C.amber, margin: "0 0 4px" },
  progressBar: { background: C.gray200, borderRadius: 8, height: 7, marginBottom: 4 },
  progressFill: { background: `linear-gradient(90deg,${C.blue},#7C3AED)`, height: 7, borderRadius: 8, transition: "width .4s" },
  progressLbl: { fontSize: 12, color: C.gray400, textAlign: "right", marginBottom: 20 },
  opcao: { background: C.white, border: `2px solid ${C.gray200}`, borderRadius: 10, padding: "13px 16px", color: C.gray800, fontSize: 14, textAlign: "left", cursor: "pointer", transition: "all .15s", fontFamily: "inherit" },
  promessa: { background: C.gray50, border: `1px solid ${C.gray200}`, borderRadius: 10, padding: 14, marginTop: 16 },
  promessaTit: { fontSize: 12, color: C.gray500, fontWeight: 600, marginBottom: 6 },
  promessaItem: { fontSize: 13, color: C.gray700, marginBottom: 3 },
  input: { background: C.gray50, border: `2px solid ${C.gray200}`, borderRadius: 10, padding: "13px 16px", color: C.gray800, fontSize: 15, outline: "none", width: "100%", boxSizing: "border-box", fontFamily: "inherit" },
  btnPrimary: { background: `linear-gradient(135deg,${C.navy},${C.blue})`, border: "none", borderRadius: 12, padding: "16px 24px", color: "#fff", fontSize: 16, fontWeight: 700, cursor: "pointer", width: "100%", marginTop: 14, fontFamily: "inherit", lineHeight: 1.4 },
  btnGreen: { background: `linear-gradient(135deg,${C.green},#10B981)`, border: "none", borderRadius: 12, padding: "16px 24px", color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer", width: "100%", lineHeight: 1.4, fontFamily: "inherit" },
  telaTrans: { maxWidth: 480, margin: "0 auto", padding: "20px 16px", minHeight: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", boxSizing: "border-box" },
  telaVsl: { maxWidth: 640, margin: "0 auto", padding: "16px 16px 80px", boxSizing: "border-box" },
  priceChip: { position: "absolute", top: 10, right: 10, background: "rgba(27,46,75,.78)", color: "#fff", borderRadius: 8, padding: "3px 9px", fontSize: 12, fontWeight: 700, letterSpacing: 0.3, zIndex: 5, pointerEvents: "none" },
  avatarCircle: { width: 38, height: 38, borderRadius: "50%", background: C.navy, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 700, flexShrink: 0, letterSpacing: 0.5 },
};
